import React, { useEffect } from 'react';
import 'card-pattern/dist/main.css';
import { landingCards, LandingCard } from '../../../config/landingCards';
import ScrollToTopBtn from '../../../components/common/ScrollToTopBtn';
import { Link } from 'react-router-dom';
import { useAppDispatch, useAppSelector } from '../../../store/hooks';
import { fetchProfile } from '../../../store/slices/profileSlice';
import Loader from '../../../components/common/Loader';
import Notifications from '../../../components/common/Notifications';
import { trackButtonClick, trackCustomPageView } from '../../../services/analytics';

const ReimbursmentLandingPage: React.FC = () => {
  const dispatch = useAppDispatch();
  const profile = useAppSelector((s) => s.profile.profile);
  const profileLoading = useAppSelector((s) => s.profile.loading);
  const profileError = useAppSelector((s) => s.profile.profileError);

  useEffect(() => {
    if (!profile && !profileLoading && !profileError) {
      dispatch(fetchProfile());
    }
  }, [dispatch, profile, profileLoading, profileError]);

  // Render landing page only when there's no profile error.



  if (profileLoading) return <Loader />;

  if (profileError) {
    return (
      <div className="min-h-[70vh] flex items-center justify-center">
        <Notifications messageInfo={profileError} status={false} />
      </div>
    );
  }

  return (
    <div className="min-h-[70vh] lg:!mx-[160px] mx-5!">
      <div className="padding-bottom-2u margin-top-4u desktop:mt-[60px]! tablet:mt-[50px]! mobile:mt-3.5!">
        <h1 className="greeting">Citizenship fee assistance</h1>
        <p className="p3 -book mt-1 desktop:mb-[42px]!">Apply for Citizenship fee assistance, manage your existing application or lookup resources here.</p>

        <h2 className="h2 tablet:mt-8! mobile:mt-3.5!">What would you like to do here?</h2>
        <p className="p3 -book mt-2 mb-8">Please select one of the following that describes your application status.</p>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-x-4! desktop:gap-y-8! mt-[32px]!">
          {landingCards
            .filter((card) => {
              // show Manager portal only when the card is marked managerOnly
              // and the API response indicates the user is a manager
              if (card.managerOnly) {
                return Boolean(profile?.isManager);
              }
              return true;
            })
            .map((card: LandingCard, idx: number) => (
            <fieldset
              key={card.title}
              className="ds-card"
              data-ds-theme="vessel"
              data-ds-variant="thumbnail"
              data-ds-version="2"
              aria-labelledby={`card-${idx}-title`}
            >
              <div className="ds-card__image">
                <img src={card.icon} alt="card icons" className="!h-[44px] !w-[44px]" />
              </div>
              <div className="ds-card__content">
                <div className="p3 -medium mb-2! text-[16px]!" id={`card-${idx}-title`}>
                  {card.title}
                </div>
                <div className="ds-card__link-container !mt-[0px]">
                  <div className="ds-card__text-link">
                    {card.link.startsWith('http') ? (
                      <a 
                        href={card.link} 
                        target={card.target} 
                        rel="noopener noreferrer" 
                        className="inline-link medium no-underline! text-[16px]!"
                        onClick={() => {
                          console.log(`📊 Analytics: Landing card clicked - ${card.title}`);
                          trackButtonClick(card.linkText ?? 'Open', 'citizenship-landing-card', { cardTitle: card.title });
                        }}
                      >
                        {card.linkText ?? 'Open'}
                      </a>
                    ) : (
                      <Link 
                        to={card.link} 
                        className="inline-link medium no-underline! text-[16px]!"
                        onClick={() => {
                          console.log(`📊 Analytics: Landing card clicked here2 - ${card.title}`);
                          trackCustomPageView( card.title === 'Submit a new Citizenship Fee Assistance application' ? '0' : card.title === 'Check your application status and upload supporting documents' ? 'upload-document-summary' : card.title === 'Manager portal' ? 'manager-portal' : '' );
                        }}
                      >
                        {card.linkText ?? 'Open'}
                      </Link>
                    )}
                  </div>
                </div>
              </div>
            </fieldset>
          ))}
        </div>
      </div>
      <div className='mb-10!'>
        <div className="mb-[-108px]! tablet:hidden">
          <ScrollToTopBtn />
        </div>

      </div>
    </div>
  );
};

export default ReimbursmentLandingPage;